import { createGLBModel } from "./GLBModel";

import { computeCurvatureDirections } from "../../geometry/computeCurvatureDirections";

import avocadoUrl from "../../../../assets/models/Avocado.glb";

const AvocadoModel = createGLBModel({
  id: "avocado",

  name: "Avocado",

  url: avocadoUrl,

  transform: {
    position: [0, 0, 0],

    rotation: [0, 0, 0],

    scale: 50.0,
  },

  capabilities: {
    normals: true,
    uv: true,
    tangents: false,
  },

  geometryProcessor: computeCurvatureDirections,
});

export default AvocadoModel;
